import background from '../assets/closing.png';
import SendSomeoneLogo from '../assets/sso-logo.png';
import './FooterSection.css';
import Space from './Space';

const FooterSection = () => {
    return (
        <div className="section footer-section">
            <img src={background} className="footer-photo" alt="footer" />
            <div
                className="footer-info"
                onClick={() => window.open('https://www.instagram.com/sendsome.one/', '_blank')}
            >
                <p>made with love by</p>
                <img src={SendSomeoneLogo} alt="logo" className="sso-logo" />
            </div>
            <Space s={64} />
        </div>
    );
};

export default FooterSection;
